import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IObjectsControllable, ILinkedPageObjectSpecifiable } from "../../../../documaker/domain/format/objects";

export interface IItemSelectTriggerBehaviorPropertyEditable {
  itemSelectTriggerBehavior(): IPropertyEditable<IObjectsControllable<ILinkedPageObjectSpecifiable>>;
}

export function instanceOfIItemSelectTriggerBehaviorPropertyEditable(instance: any): instance is IItemSelectTriggerBehaviorPropertyEditable {
  return instance
      && instance.itemSelectTriggerBehavior
      && instanceOfIPropertyEditable<IObjectsControllable<ILinkedPageObjectSpecifiable>>(instance.itemSelectTriggerBehavior());
}
